import {
    IonButton,
    IonButtons,
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonModal,
    IonRow,
    IonSpinner,
    IonTitle,
    IonToolbar
} from "@ionic/react";
import { checkmarkDoneCircleOutline, warningOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import {
    resetMassiveSign,
    setMassiveSignStatus,
    setShowMassiveSign
} from "../../../store/documentsSignerList";
import { selectMassiveSignStatus } from "../../../store/documentsSignerList/selectors/selectMassiveSignStatus";
import { selectSignedCounter } from "../../../store/documentsSignerList/selectors/selectSignedCounter";
import { selectSignerDocuments } from "../../../store/documentsSignerList/selectors/selectSignerDocuments";

export const SignStatus = () => {
  const selectedDocuments = useSelector(selectSignerDocuments).filter(({ checked }) => checked);
  const signStatus = useSelector(selectMassiveSignStatus);
  const signedCounter = useSelector(selectSignedCounter);
  const dispatch = useDispatch();

  return (
    <>
      <IonModal isOpen={["pending", "fulfilled"].includes(signStatus)} backdropDismiss={false}>
        <IonHeader translucent>
          <IonToolbar>
            <IonTitle>Firma masiva de acuerdos</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <br />
          <br />
          <IonGrid style={{ height: "100%", width: "100%" }} class="ion-padding">
            <IonRow class="ion-align-items-baseline" style={{ height: "100%" }}>
              <IonCol size="12" class="ion-padding-top">
                {signStatus === "pending" && (
                  <>
                    <IonSpinner name="lines" />
                    <h3>
                      {signedCounter} de {selectedDocuments.length} acuerdos firmados correctamente
                    </h3>
                  </>
                )}
                {signStatus === "fulfilled" && selectedDocuments.length - signedCounter === 0 && (
                  <>
                    <IonIcon
                      icon={checkmarkDoneCircleOutline}
                      size="large"
                      color="success"
                    ></IonIcon>
                    <h3>
                      {signedCounter} de {selectedDocuments.length} acuerdos firmados correctamente
                    </h3>
                  </>
                )}

                {signStatus === "fulfilled" && selectedDocuments.length - signedCounter > 0 && (
                  <>
                    <IonIcon icon={warningOutline} size="large" color="warning"></IonIcon>
                    <h3>
                      {signedCounter} de {selectedDocuments.length} acuerdos firmados correctamente
                    </h3>
                  </>
                )}
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
        {signStatus === "fulfilled" && (
          <IonFooter>
            <IonToolbar color="light">
              <IonButtons slot="end">
                <IonButton
                  routerLink="/app/acuerdos/firma"
                  color="primary"
                  fill="solid"
                  onClick={() => {
                    dispatch(resetMassiveSign());
                    dispatch(setShowMassiveSign(false));
                    dispatch(setMassiveSignStatus(""));
                  }}
                >
                  Aceptar
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonFooter>
        )}
      </IonModal>
    </>
  );
};
